/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.7",
    versionName: "0.2.0-nightly.2025.11.7",
    versionChannel: "nightly",
    buildDate: "2025-11-07T00:09:36.493Z",
    commitHash: "bbd45eab8a3c72d5b1629a363efdbf20cbde8a55",
};
